import React, {Component} from 'react';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class UseSecondaryGroup extends Component {
    render() {
        const options = {0: 'in', 1: 'and'};

        return (
            <SimpleSelect
                className="input-sm"
                value={this.props.value}
                options={options}
                onChange={this.props.onChange}
            />
        );
    }
}

export default UseSecondaryGroup;
